//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  OutlinedInput,
} from '@mui/material';

// === API ===
import { on, removeListener, sendMessageData } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function UserSelect( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { label } = props;
  const { onChange } = props;

  const [ users , setUsers ] = useState( [] );
  const [ selectedUsers, setSelectedUsers ] = useState( [] );
  
  // === STYLE ===
  const _styles = {
    container: {
      display: 'block',
    },
    user_select: {
      display: 'block',
      width: '18rem',
      marginBottom: '1rem',
    },
  };

  // === ATTRIBUTES ===
  const
    USERNAMES = {
      sx       : _styles.user_select ,
      labelId  : "user-select-label" ,
      id       : 'user-select'       ,
      multiple : true,
      value    : selectedUsers,    
      input    : <OutlinedInput label={label || 'Users'}/>,
      onChange : handleChange        ,
      children : [ displayUsers() ]  ,
      renderValue : (selected) => selected.map( (userId) => users.find( (user) => user.Id === userId )?.Username ).join(', '),
      MenuProps: {
        PaperProps   : {
         style: {
           maxHeight : 600,
         },
        },
        anchorOrigin : {
          vertical   : 'bottom',
          horizontal : 'center'
        },
      }
    },
    USERNAMES_LABEL = {
      id       : 'user-select-label',
      children : [ label ? label : 'Users' ],
    };

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleChange(event) {
    //-----------------------------------------------------------------
    const selectedList = event.target.value;
    setSelectedUsers(selectedList);
    onChange(selectedList);
  }

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function listener_users(data) {
      //-----------------------------------------------------------------
      setUsers(data.users);
    }

    on( 'USERNAMES' , listener_users );

    sendMessageData( 'USERNAMES_REQUEST' );

    return () => {
      removeListener( 'USERS' , listener_users );
    };
  }, [] ); // empty dependency = called only once at startup

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <FormControl sx={ _styles.container }>
        <InputLabel { ...USERNAMES_LABEL  } />
        <Select     { ...USERNAMES        } />
      </FormControl>
    )
  }

  //-----------------------------------------------------------------
  function displayUsers() {
    //-----------------------------------------------------------------
    return users.map( user => {
      return (
        <MenuItem key={user.Id} value={user.Id}>
          <Checkbox checked = {selectedUsers.indexOf(user.Id) > -1 }/>
          {user.Username}
        </MenuItem>
      )
    } );
  }

  //#endregion

  return display();
}